module.exports = __webpack_public_path__ + "img/17.4d6da547.png";